// ** React Imports
import { Fragment, useState } from "react";

// ** MUI Components
import {
  Avatar,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  InputAdornment,
  Tooltip,
  Paper,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Checkbox,
  Collapse
} from "@mui/material";
import MuiStep from "@mui/material/Step";
import { styled, useTheme} from "@mui/material/styles";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";



// ** Icon Imports
import Icon from "../../../components/icon";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";

// ** Custom Component Imports
import CustomTextField from "../../../components/mui/text-field";
import CustomChip from "../../../components/mui/chip";
import StepperCustomDot from "../../../components/Stepper/StepperCustomDot";
import CustomAvatar from "../../../components/mui/avatar";
import DateRangeCalendar from "../../Customers/component/DateRangeCalendar";
import CustomAutocomplete from "../../../components/mui/autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";

// ** Styled Component
import StepperWrapper from "../../../components/styles/mui/stepper";

// ** Utils Import
import { hexToRGBA } from "../../../components/utils/hex-to-rgba";

// ** Third Party Imports
import Draggable from "react-draggable";
import dayjs from 'dayjs';

// ** Dialog Imports
// import AddServiceDialog from "./AddService";
import AddServiceDialog from "../../Assessments/component/AddService";
import AddBundleDialog from "../../Assessments/component/AddBundle";
import AddJobsiteDialog from "../../Customers/component/AddJobsite";
import AddContactDialog from "../../Customers/component/AddContact";
import { useCreateRequestLogic } from "../logic/CreateRequestLogic";
import AddCustomerDialog from "screens/Customers/component/AddCustomer";
import TagManagementDialog from "screens/Customers/component/TagManagement";
import PreAttachment from "./PreAttachment";
import { ToastContainer } from "react-toastify";

const steps = [
  {
    serial: "1",
    title: "Request Details",
    icon: "tabler:list-details",
  },
  {
    serial: "2",
    title: "Work Requirements",
    icon: "tabler:align-box-left-stretch",
  },
  {
    serial: "3",
    title: "Link Records",
    icon: "tabler:link",
  },
  {
    serial: "4",
    title: "Notes",
    icon: "tabler:ballpen",
  },
  {
    serial: "5",
    title: "Assign To",
    icon: "tabler:user-share",
  },
];

const Step = styled(MuiStep)(({ theme }) => ({
  "& .MuiStepLabel-root": {
    paddingTop: 0,
  },
  "& .MuiStepLabel-iconContainer": {
    display: "none",
  },
  "& .step-subtitle": {
    color: `${theme.palette.text.disabled} !important`,
  },
  "& + svg": {
    color: theme.palette.text.disabled,
  },
  "&.Mui-completed .step-title": {
    color: theme.palette.text.disabled,
  },
}));

const StepperHeaderContainer = styled(CardContent)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    borderRight: 0,
    borderBottom: 'none',
  },
}));

const recordOptions = [
  { label: "EST-001", text: "House Cleaning Beta Site", status: "TO DO" },
  {
    label: "EST-002",
    text: "House Remodeling Alpha Site",
    status: "COMPLETED",
  },
];

function DraggablePaper(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const CreateRequest = ({ 
  open, 
  handleClose,
  setLoading,
 }) => {
  const theme = useTheme();
// 0
  const [activeStep, setActiveStep] = useState(0);
   
    
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { CreateRequestProps } = useCreateRequestLogic({handleClose,activeStep,setActiveStep,steps,setLoading});

  const {
    isServiceEmpty,
    setIsServiceEmpty,
    openAddBundle,
    setOpenAddBundle,
    isBundleEmpty,
    setIsBundleEmpty,
    //handleOpenBundleDlg,
    handleCloseBundleDlg,
    handleSave,
    renderContent,
    handleCloseContactDialog,
    handleCloseServiceDlg,
    handleServiceNext,
    openAddService,
    openNewCustomerDlg,
    openNewContactDlg,
    NProgress,
    setOpenNewCustomerDlg,
    jobsite,
    propertyAreaList,
    alertList,
    customer,
    toast,    
    openNewJobsiteDlg,
    setOpenNewJobsiteDlg,
    allContacts,
    propertyArea,
    areaMeasurement,
    activeStepJobsite,
    jobsiteContent,
    clearPropertyArea,
    fetchPropertyArea,
    clearAreaMeasurement,
    setActiveStepJobsite,
    setPropertyArea,
    setAreaMeasurement,
    navigate,
    setAlertList,
    handleJobsiteChange,
    handleBack, 
    fetchContacts, 
    handleCloseNewJobsiteDlg,
    files,
    setFiles,
    fetchJobsites,
    openTagManagementDlg,
    handleCloseTagManagementDlg,
    handleAddTag,
    handleDeleteTag,
    serviceRequest,
    Tag,
    setTag,
    resetRequest,
    openUploadDlg,
    handleOpenUploadDlg,
    handleCloseUploadDlg,
    uploadFiles,
    setUploadFiles,
    sf,
    f,
    fetchWorkRequirements,
    fetchData,
    allCustomers,
    serviceContent,
    ResetServiceContent,
    openNewPropertyDlg,
    setOpenNewPropertyDlg,
    propertyContent,
    setPropertyContent,
    Indoor,
    setIndoor,
    Outdoor,
    setOutdoor,
    handleCloseNewPropertyDlg,
    listOfMeasurements, 
    setListOfMeasurements,
    handleOpenNewPropertyAreaDlg, 
    allJobsites,
    handleDeleteFile,
    AddServiceProps,
    AddBundleProps,
    AttachmentProps,
    handleCloseServiceRequestDialog,
  } = CreateRequestProps;  

  // const {ResetServices} = WorkReqProps;  

  const handleRequestClose = () =>{
    resetRequest();
    handleClose(false);    
    ResetServiceContent();
    handleCloseServiceRequestDialog();
    setActiveStep(0);
  }
 
  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={() => handleRequestClose()}
        PaperComponent={isSmallScreen ? Paper : DraggablePaper}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          sx: {
            height: "100%",
            maxHeight: "95vh",
            width: isSmallScreen ? "95vw" : "auto",
            m: isSmallScreen ? 2 : 0,
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            alignItems: isSmallScreen ? "flex-end" : "center",
          },
        }}
      >
        <DialogTitle
          style={{
            cursor: isSmallScreen ? "default" : "move",
            borderBottom: "1px solid #D9D9D9",
            padding: isSmallScreen ? theme.spacing(2) : theme.spacing(4),
          }}
          id="draggable-dialog-title"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: isSmallScreen ? 2 : 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <Typography variant="h3" fontWeight="bold">
                Create Request
              </Typography>
              {serviceRequest?.requestID > 0 && (
                <CustomChip
                  rounded
                  skin="light"
                  sx={{ lineHeight: 1 }}
                  color="info"
                  label={
                    `REQ-${serviceRequest?.requestID
                      .toString()
                      .padStart(3, "0")}` || ""
                  }
                />
              )}
            </Box>
            <StepperHeaderContainer
              sx={{
                width: isSmallScreen ? "100%" : "auto",
                pt: isSmallScreen ? 0 : 0,
              }}
            >
              <StepperWrapper>
                <Stepper
                  activeStep={activeStep}
                  connector={<></>}
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: isSmallScreen ? "wrap" : "nowrap",
                    paddingTop: isSmallScreen ? "0" : "1.5rem !important",
                    gap: isSmallScreen ? "5px" : "16px",
                    "& .MuiStep-root": {
                      padding: isSmallScreen ? "5px" : "0",
                      flex: isSmallScreen ? "1 1 auto" : "none",
                    },
                  }}
                >
                  {steps.map((step, index) => {
                    const RenderAvatar =
                      activeStep >= index ? CustomAvatar : Avatar;
                    const isStepActive = activeStep === index;
                    return (
                      <Step key={index} sx={{ paddingBottom: 0 }}>
                        <StepLabel StepIconComponent={StepperCustomDot}>
                          <div className="step-label">
                            <RenderAvatar
                              variant="rounded"
                              {...(activeStep >= index && {
                                skin: "light",
                              })}
                              {...(isStepActive && { skin: "filled" })}
                              {...(activeStep >= index && {
                                color: "success",
                              })}
                              sx={{
                                ...(isStepActive && {
                                  boxShadow: (theme) => theme.shadows[3],
                                  color: "#fff", // white when active
                                }),
                                ...(activeStep > index && {
                                  color: (theme) => theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.48)' : hexToRGBA(theme.palette.primary.main, 0.4),
                                }),
                              }}
                            >
                              <Icon icon={step.icon} />
                            </RenderAvatar>
                            <div>
                              <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                {...(activeStep === index && {
                                  fontWeight: "550",
                                  color: "text.primary",
                                })}
                              >
                                {step.title}
                              </Typography>
                            </div>
                          </div>
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </StepperWrapper>
            </StepperHeaderContainer>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ position: "relative" }}>
          <Box sx={{ height: "100%" }}>{renderContent()}</Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: isSmallScreen ? "16px !important" : "20px 24px !important",
            boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
            zIndex: 1,
            flexDirection: isSmallScreen ? "column-reverse" : "row",
            gap: isSmallScreen ? 2 : 0,
          }}
          className="dialog-actions-dense"
        >
          <Box sx={{ width: isSmallScreen ? "100%" : "auto" }}>
            <Button
              variant="contained"
              color="info"
              onClick={() => handleRequestClose()}
              fullWidth={isSmallScreen}
            >
              Cancel
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: isSmallScreen ? "100%" : "auto",
              gap: isSmallScreen ? 2 : 0,
              flexDirection: isSmallScreen ? "column" : "row",
            }}
          >
            <Button
              variant="outlined"
              color="main"
              disabled={activeStep === 0}
              onClick={handleBack}
              fullWidth={isSmallScreen}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="main"
              sx={{ ml: isSmallScreen ? 0 : 5 }}
              onClick={handleServiceNext}
              fullWidth={isSmallScreen}
            >
              {activeStep === steps.length - 1 ? "Save Changes" : "Next Step"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Add Customer Dialog */}

      <AddCustomerDialog
        open={openNewCustomerDlg}
        setOpenNewCustomerDlg={setOpenNewCustomerDlg}
        fetchData={fetchData}
        allCustomers={allCustomers}
      />

      <AddJobsiteDialog
        open={openNewJobsiteDlg}
        handleClose={handleCloseNewJobsiteDlg}
        setJobsiteOpen={setOpenNewJobsiteDlg}
        customer={customer}
        fetchContactData={fetchContacts}
        toast={toast}
        jobsite={jobsite}
        handleJobsiteChange={handleJobsiteChange}
        navigate={navigate}
        NProgress={NProgress}
        fetchContacts={fetchContacts}
        fetchJobsites={fetchJobsites}
        contacts={allContacts}
        propertyArea={propertyArea}
        setPropertyArea={setPropertyArea}
        areaMeasurement={areaMeasurement}
        setAreaMeasurement={setAreaMeasurement}
        setLoading={setLoading}
        activeStep={activeStepJobsite}
        setActiveStep={setActiveStepJobsite}
        clearAreaMeasurement={clearAreaMeasurement}
        fetchPropertyArea={fetchPropertyArea}
        propertyAreaList={propertyAreaList}
        clearPropertyArea={clearPropertyArea}
        jobsiteContent={jobsiteContent}
        alertList={alertList}
        setAlertList={setAlertList}
        files={files}
        setFiles={setFiles}
      />

      {/* Add Jobsite Dialog */}

      {/* Add Contact Dialog */}
      <AddContactDialog
        open={openNewContactDlg}
        handleClose={handleCloseContactDialog}
        customer={customer}
        setLoading={setLoading}
        fetchContactData={fetchContacts}
        toast={toast}
        contacts={allContacts}
      />

      <TagManagementDialog
        open={openTagManagementDlg}
        handleClose={handleCloseTagManagementDlg}
        data={{ title: "Tag Management" }}
        handleAddTag={handleAddTag}
        handleDeleteTag={handleDeleteTag}
        tags={serviceRequest?.tags}
        tag={Tag}
        setTag={setTag}
      />

      {/* Add Service Dialog */}
      {/* <AddServiceDialog
        open={openAddService}
        serviceContent={serviceContent}
        handleClose={handleCloseServiceDlg}
        handleOpenUploadDlg={handleOpenUploadDlg}
        setFiles = {setUploadFiles}  
        sf = {sf} 
        f = {f}
        navigate= {navigate}
        jobsite = {jobsite}
        serviceRequest={serviceRequest}
        toast={toast}
        fetchWorkRequirements = {fetchWorkRequirements}
        handleOpenNewPropertyAreaDlg = {handleOpenNewPropertyAreaDlg} 
        handleDeleteFile={handleDeleteFile}       
        {...WorkReqProps}
      /> */}
      <AddServiceDialog {...AddServiceProps} />

      <AddBundleDialog {...AddBundleProps} />

      <PreAttachment Title="Upload Attachment" {...AttachmentProps} />

      {/*<ToastContainer />*/}
    </>
  );
};

export default CreateRequest;
